// L'annuaire et le suivi des personnalités (15 octobre 2026) : ce que partagent leurs écrans.
// Le genre d'une personne n'est jamais deviné : « Ce qu'on en dit », « Ceux qui en parlent ».
export default {
  plateforme: {
    x: 'X',
    instagram: 'Instagram',
    facebook: 'Facebook',
    linkedin: 'LinkedIn',
    tiktok: 'TikTok',
    youtube: 'YouTube',
    reddit: 'Reddit',
    presse: 'Presse',
    seance: 'Séance',
    web: 'Web',
    telegram: 'Telegram',
    site: 'Site',
  },
  sigle: { x: 'X', instagram: 'IG', facebook: 'FB', linkedin: 'IN', tiktok: 'TT', youtube: 'YT', site: 'Web' },
  sens: { favorable: 'favorable', neutre: 'neutre', defavorable: 'défavorable' },
  position: { soutien: 'Soutien', nuance: 'Nuancée', reserve: 'Réservée', oppose: 'Opposée' },
  genre: { dit: 'Ses mots', sur: 'Ce qu’on en dit' },
  institution: { AN: 'Assemblée nationale', SENAT: 'Sénat', GOUVERNEMENT: 'Gouvernement', PE: 'Parlement européen', AUTRES: 'Partis, régions, villes', PRESIDENCE: 'Présidence', PARTI: 'Partis', REGION: 'Régions', MAIRIE: 'Villes', ajoutees: 'Ajoutées' },
  citation: {
    guillemets: '« {texte} »',
    source: 'Voir la source',
    releve: 'relevée le {quand}',
    persona: 'parmi « {nom} »',
    reactions: '{n} réactions',
    partages: '{n} partages',
    commentaires: '{n} commentaires',
    vues: '{n} vues',
  },
  alerte: {
    genre: { pic: 'Pic', tonalite: 'Tonalité', persona: 'Persona qui bascule', position: 'Position' },
    pic: 'On en parle {facteur} fois plus que d’habitude.',
    tonaliteHausse: 'Sa note monte à {note}, {ecart} points au-dessus de sa moyenne de la semaine ({avant}).',
    tonaliteBaisse: 'Sa note tombe à {note}, {ecart} points sous sa moyenne de la semaine ({avant}).',
    personaCamp: '« {persona} » change de camp : {avant} la semaine d’avant, {apres} maintenant.',
    personaPoids: '« {persona} » pèse soudain {part} % de la conversation, contre {avant} % la semaine d’avant.',
    positionNouvelle: 'Prend position sur « {sujet} » : {position}.',
    positionChange: 'Change de position sur « {sujet} » : {avant}, puis {position}.',
  },
  suivre: 'Suivre',
  suivie: 'Suivie',
  nePlusSuivre: 'Ne plus suivre',
  quota: '{n} suivis sur {max}',
  complets: 'Vos {max} suivis sont utilisés. Ne plus suivre une personnalité en libère un.',
  erreur: 'Impossible de charger.',
  fermer: 'Fermer',
  reessayer: 'Réessayer',
}
